import { flow, makeObservable, observable } from 'mobx';

import { CaseAdapter } from '@shared/CaseAdapter';
import BaseStore from './BaseStore';
import OpenDrivingSchoolApi from '../api/open_driving_school_api';
import DepartmentsApi from '../api/departments_api';

class OpenDrivingSchoolStore extends BaseStore {
  isLoading = false;
  isDepartmentsDataLoading = false;
  applicant = {};
  departments = [];

  constructor() {
    super();

    makeObservable(this, {
      isLoading: observable,
      isDepartmentsDataLoading: observable,
      applicant: observable,
      departments: observable,
    });
  }

  postNewApplicant = flow(
    function* ({
      formData, setErrors, setStatus, setSubmitting,
    }) {
      this.isLoading = true;

      try {
        const { data } = yield OpenDrivingSchoolApi.postNewApplicant(CaseAdapter.toBackFormat(formData));
        this.applicant = data;
        setStatus({ success: true });
      } catch (e) {
        if (e.response?.data?.errorMessages?.message) {
          const { message } = e.response.data.errorMessages;
          Object.keys(CaseAdapter.toFrontFormat(message)).forEach((errorField) => {
            const errorMessage = message[errorField];
            if (Array.isArray(errorMessage)) {
              message[errorField] = errorMessage.join(',');
            }
          });

          setErrors(message);
        } else {
          // eslint-disable-next-line no-console
          console.error(e);
          setStatus({ success: false });
        }
        setSubmitting(false);
      }
    },
  );

  getDepartments = flow(function* () {
    this.isDepartmentsDataLoading = true;

    try {
      const { data } = yield DepartmentsApi.getDepartments();
      this.departments = [...data].sort((departmentA, departmentB) => {
        if (departmentA.name.toLowerCase() < departmentB.name.toLowerCase()) {
          return -1;
        }

        if (departmentA.name.toLowerCase() > departmentB.name.toLowerCase()) {
          return 1;
        }

        return 0;
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.isDepartmentsDataLoading = false;
    }
  });
}

export default new OpenDrivingSchoolStore();
